export enum IconSize {
  EXTRA_SMALL = "xs",
  SMALL = "sm",
  MEDIUM = "md",
  LARGE = "lg",
}

export enum IconName {
  AMENITIES_BATHROOM = "amenities/bathroom",
  AMENITIES_COFFEE = "amenities/coffee",
  AMENITIES_FERRY = "amenities/ferry",
  AMENITIES_GAS_STATION = "amenities/gas-station",
  AMENITIES_GLOBE = "amenities/globe",
  AMENITIES_HOTEL = "amenities/hotel",
  AMENITIES_MUSEUM = "amenities/museum",
  AMENITIES_PARK = "amenities/park",
  AMENITIES_PARKING = "amenities/parking",
  AMENITIES_PARKING_FEE = "amenities/parking-fee",
  AMENITIES_PHARMACY = "amenities/pharmacy",
  AMENITIES_PLAYGROUND = "amenities/playground",
  AMENITIES_RESTAURANT = "amenities/restaurant",
  AMENITIES_SHOPPING = "amenities/shopping",
  AMENITIES_STORE = "amenities/store",
  AMENITIES_SUPERMARKET = "amenities/supermarket",
  AMENITIES_BAKERY = "amenities/bakery",
  AMENITIES_CONVENIENCE_STORE = "amenities/convenience_store",
  AMENITIES_TOLL = "amenities/toll",
  AMENITIES_VEHICLE = "amenities/vehicle",
  AMENITIES_CHARGE_STATION = "amenities/charge-station",
  AMENITIES_CAR_WASH = "amenities/car-wash",
  AMENITIES_SECURE_PARKING = "amenities/camera",
  AMENITIES_TRUCK_REPAIR = "amenities/repair",
  AMENITIES_OVERNIGHT_PARKING = "amenities/parking-overnight",

  CHARGE_SPEED_ERROR = "charge-speed/error",
  CHARGE_SPEED_FAST = "charge-speed/fast",
  CHARGE_SPEED_PLANNED = "charge-speed/planned",
  CHARGE_SPEED_SELECTED = "charge-speed/selected",
  CHARGE_SPEED_SLOW = "charge-speed/slow",
  CHARGE_SPEED_TURBO = "charge-speed/turbo",
  CHARGE_SPEED_UNKNOWN = "charge-speed/unknown",

  CHARGERS_CHADEMO = "chargers/chademo",
  CHARGERS_DEFAULT = "chargers/default",
  CHARGERS_DOMESTIC_A = "chargers/domestic-a",
  CHARGERS_DOMESTIC_B = "chargers/domestic-b",
  CHARGERS_DOMESTIC_C = "chargers/domestic-c",
  CHARGERS_DOMESTIC_D = "chargers/domestic-d",
  CHARGERS_DOMESTIC_E = "chargers/domestic-e",
  CHARGERS_DOMESTIC_F = "chargers/domestic-f",
  CHARGERS_DOMESTIC_G = "chargers/domestic-g",
  CHARGERS_DOMESTIC_H = "chargers/domestic-h",
  CHARGERS_DOMESTIC_I = "chargers/domestic-i",
  CHARGERS_DOMESTIC_J = "chargers/domestic-j",
  CHARGERS_DOMESTIC_K = "chargers/domestic-k",
  CHARGERS_DOMESTIC_L = "chargers/domestic-l",
  CHARGERS_MCS = "chargers/mcs",
  CHARGERS_T1 = "chargers/t1",
  CHARGERS_T1_COMBO = "chargers/t1-combo",
  CHARGERS_T2 = "chargers/t2",
  CHARGERS_T2_COMBO = "chargers/t2-combo",
  CHARGERS_T3A_C = "chargers/t3a-c",
  CHARGERS_TESLA_R = "chargers/tesla-r",
  CHARGERS_TESLA_S = "chargers/tesla-s",
  CONTROLS_CHANGE = "controls/change",
  CONTROLS_CHECK = "controls/check",
  CONTROLS_CHEVRON_DOWN = "controls/chevron-down",
  CONTROLS_CHEVRON_UP = "controls/chevron-up",
  CONTROLS_COPY = "controls/copy",
  CONTROLS_PHONE = "controls/phone",
  CONTROLS_DIRECTION = "controls/direction",
  CONTROLS_EXTERNAL = "controls/external",
  CONTROLS_GRAB = "controls/grab",
  CONTROLS_MINUS = "controls/minus",
  CONTROLS_PLUS = "controls/plus",
  CONTROLS_REPLACE = "controls/replace",
  CONTROLS_REPORT = "controls/report",
  CONTROLS_SEARCH = "controls/search",
  CONTROLS_SEARCH_SMALL = "controls/search-small",
  CONTROLS_SEARCH_EMAIL = "controls/search-email",
  CONTROLS_SETTINGS = "controls/settings",
  CONTROLS_SHARE = "controls/share",
  CONTROLS_SHOW = "controls/show",
  CONTROLS_TRASH = "controls/trash",
  CONTROLS_DELIVERY = "controls/delivery",
  CONTROLS_DRAG = "controls/drag",
  CONTROLS_PICKUP = "controls/pickup",
  CONTROLS_CLOSE = "controls/close",
  CONTROLS_LOOK_AROUND = "controls/look-around",
  CONTROLS_FILTERS_MAP = "controls/map-filters",
  FILLED_CHARGE = "filled/charge",
  FILLED_DELIVERY = "filled/delivery",
  FILLED_INFO = "filled/info",
  FILLED_PICK_UP = "filled/pick-up",
  FILLED_PRICE = "filled/price",
  FILLED_TIME = "filled/time",
  FILLED_WARNING = "filled/warning",
  FILLED_WEIGHT = "filled/weight",
  FILLED_TRUCK_ACCESSIBLE = "filled/truck-accessible",

  GENERAL_CHARGER = "general/charger",
  GENERAL_FILTERS = "general/filters",
  GENERAL_LOCATION = "general/location",
  GENERAL_LOCATION_ME = "general/location-me",
  GENERAL_PHONE = "general/phone",
  GENERAL_ORIGIN = "general/origin",
  GENERAL_DESTINATION = "general/destination",
  GENERAL_RECENT = "general/recent",
  GENERAL_STARS = "general/stars",
  GENERAL_WARNING = "general/warning",
  GENERAL_NO_CARD = "general/no-card",
  GENERAL_CHANGE = "general/change",
  GENERAL_ERROR = "general/error",
  GENERAL_CURRENT_WEATHER = "general/current-weather",
  GENERAL_SUMMER = "general/summer",
  GENERAL_WINTER = "general/winter",
  GENERAL_DRIVING = "general/driving",
  GENERAL_WALKING = "general/walking",
  GENERAL_HISTORY = "general/history",
  GENERAL_AMENITIES = "general/amenities",
  GENERAL_ALT_STATIONS = "general/alt-stations",
  GENERAL_ENHANCED_ROUTE = "general/enhanced-route",
  GENERAL_PARKING_TIMELINE = "general/parking-timeline",

  // TODO: Discuss with Richard (Design), how `GENERAL_SHOW` and `GENERAL_HIDE`
  // should be properly categorized, moved it into `general` for now.
  GENERAL_SHOW = "general/show",
  GENERAL_HIDE = "general/hide",
  GENERAL_TRUCK_N1 = "general/truck-n1",
  GENERAL_TRUCK_N2 = "general/truck-n2",
  GENERAL_TRUCK_N3 = "general/truck-n3",
  GENERAL_TRUCK_TRAILER = "general/truck-trailer",
  GENERAL_TRUCK_N1_UNAVAILABLE = "general/truck-n1-unavailable",
  GENERAL_TRUCK_N2_UNAVAILABLE = "general/truck-n2-unavailable",
  GENERAL_TRUCK_N3_UNAVAILABLE = "general/truck-n3-unavailable",

  MAP_CENTER_OFF = "map/center-off",
  MAP_CENTER_ON = "map/center-on",
  MAP_CHARGE_SELECTED = "map/charge-selected",

  MAP_PORSCHE_DESTINATION = "map/porsche-destination",
  MAP_PORSCHE_LOUNGE = "map/porsche-lounge",
  MAP_PORSCHE_PARTNER = "map/porsche-partner",

  TIMELINE_DEFAULT_AVAILABLE_100 = "timeline/DEFAULT-AVAILABLE-100",
  TIMELINE_DEFAULT_AVAILABLE_200 = "timeline/DEFAULT-AVAILABLE-200",
  TIMELINE_DEFAULT_AVAILABLE_300 = "timeline/DEFAULT-AVAILABLE-300",

  MAP_MARKER = "map/marker",
  MAP_MARKER_AVAILABLE = "map/marker-AVAILABLE",
  MAP_MARKER_BLOCKED = "map/marker-BLOCKED",
  MAP_MARKER_CHARGING = "map/marker-CHARGING",
  MAP_MARKER_INOPERATIVE = "map/marker-INOPERATIVE",
  MAP_MARKER_OUTOFORDER = "map/marker-OUTOFORDER",
  MAP_MARKER_PLANNED = "map/marker-PLANNED",
  MAP_MARKER_REMOVED = "map/marker-REMOVED",
  MAP_MARKER_RESERVED = "map/marker-RESERVED",
  MAP_MARKER_UNKNOWN = "map/marker-UNKNOWN",
  MAP_POWER_100 = "map/power-100",
  MAP_POWER_200 = "map/power-200",
  MAP_POWER_300 = "map/power-300",
  // TODO: When swapping icons we need to clean up sizing.
  // This is a 24px icon which only renders as 20px icon through the folder.
  MAP_ALTERNATIVE_STATIONS = "map/alternative-stations",

  MAP_CLUSTER = "map/cluster",
  MAP_ORIGIN = "map/origin",
  MAP_DESTINATION = "map/destination",
  MAP_FERRY = "map/ferry",
  MAP_VIA = "map/via",
  MAP_ALTERNATIVE_STATION = "map/alternative-station",
  MAP_ALTERNATIVE_STATION_SELECTED = "map/alternative-station-selected",

  // TODO: Only specified to be used for the toast.
  // All other status icons are dynamically loaded and thus not default.
  // Capitalization is only enabled because of the BE enum pattern.
  MAP_STATION_TURBO = "map/DEFAULT-AVAILABLE-300",

  NAVIGATION_MENU_DOTS = "navigation/menu-dots",
  NAVIGATION_CHEVRON_RIGHT = "navigation/chevron-right",
  NAVIGATION_CHEVRON_DOWN = "navigation/chevron-down",
  NAVIGATION_CHEVRON_UP = "navigation/chevron-up",
  NAVIGATION_CHEVRON_LEFT = "navigation/chevron-left",
  NAVIGATION_CHEVRON_LEFT_LARGE = "navigation/chevron-left-large",
  NAVIGATION_ARROW_RIGHT = "navigation/arrow-right",
  NAVIGATION_CLOSE = "navigation/close",
  NAVIGATION_CLOSE_FILLED = "navigation/close-filled",
  NAVIGATION_CLOSE_LARGE = "navigation/close-large",
  NAVIGATION_LOADING = "navigation/loading",
  NAVIGATION_MENU = "navigation/menu",

  PRODUCTS_ISOLINE = "products/isoline",
  PRODUCTS_TRIP = "products/trip",
  PRODUCTS_ISOLINE_FULL = "products/isoline-full",
  PRODUCTS_OPERATIONAL = "products/operational",
  PRODUCTS_OPERATIONAL_FILL = "products/operational-fill",

  PRODUCTS_PRICE = "products/price",
  PRODUCTS_PRICE_FILL = "products/price-fill",

  SECTIONS_OPERATIONAL = "sections/operational",
  SECTIONS_PRICE = "sections/price",
  SECTIONS_CARD = "sections/card",
  SECTIONS_AMENITY = "sections/amenity",
  SECTIONS_INFORMATION = "sections/information",
  SECTIONS_ID = "sections/id",
  SECTIONS_GRAPH = "sections/graph",
  SECTIONS_CLIMATE = "sections/climate",
  SECTIONS_INFO = "sections/info",
  SECTIONS_PREDICTION = "sections/prediction",
  SECTIONS_RANGE = "sections/range",
  SECTIONS_OPERATOR = "sections/operator",
  SECTIONS_ROUTE = "sections/route",
  SECTIONS_SCHEDULE = "sections/schedule",
  SECTIONS_VEHICLE = "sections/vehicle",
  SECTIONS_CHARGE = "sections/charge",
  SECTIONS_TRUCK = "sections/truck",
  SETTINGS_CONTACT = "settings/contact",
  SETTINGS_GENERAL = "settings/general",
  SETTINGS_BETA_FEATURES = "settings/beta-features",
  SETTINGS_FEATURE_REQUEST = "settings/feature-request",
  SETTINGS_COOKIES = "settings/cookies",
  SETTINGS_LEGEND = "settings/legend",
  SETTINGS_FAQ = "settings/faq",
  REPORTING_EMBEDDED = "reporting/embedded",
  REPORTING_OPERATIONAL = "reporting/operational",
  REPORTING_RECYCLING = "reporting/recycling",
  REPORTING_MIX = "reporting/mix",
  REPORTING_OIL = "reporting/oil",

  LOGOS_CHARGETRIP = "logos/chargetrip",
  LOGOS_CHARGELEAGUE = "logos/chargeleague",
  LOGOS_IONITY = "logos/ionity",
  LOGOS_ELECTRA = "logos/electra",
  LOGOS_FASTNED = "logos/fastned",
  LOGOS_ATLANTE = "logos/atlante",

  WEATHER_CURRENT = "weather/current",
  WEATHER_SUMMER = "weather/summer",
  WEATHER_WINTER = "weather/winter",
}

export interface IconProps {
  name: IconName;
  isBoxed?: boolean;
  size?: IconSize;
  hasCurrentColor?: boolean;
}
